import { defaultPriceOptions, getPriceFormatted, getFirstOfferAlternatives } from "@i22/rocket";
import Heading from "./component-library6.mjs";
import LinkButton from "./component-library3.mjs";
import OfferTileColors from "./component-library173.mjs";
import OfferTileVariant from "./component-library174.mjs";
import Prices from "./component-library30.mjs";
import "./component-library175.mjs";
import normalizeComponent from "./component-library81.mjs";
const _sfc_main = {
  name: "OfferTile",
  components: {
    Heading,
    LinkButton,
    OfferTileColors,
    OfferTileVariant,
    Prices
  },
  props: {
    offer: { type: Object, required: true },
    tagTitle: { type: String, default: "h2" },
    linkTag: { type: String, default: "a" },
    priceOptions: { type: Object, default: () => defaultPriceOptions },
    noTextBrand: { type: Boolean },
    highlightTile: { type: Boolean },
    highlightFlagHex: { type: String, default: "e20074" },
    rectangularBadgeHex: { type: String, default: "317CB3" }
  },
  computed: {
    title() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
      if ((_a = this.offer) == null ? void 0 : _a.contract)
        return this.offer.contract.name;
      if ((_d = (_c = (_b = this.offer) == null ? void 0 : _b.product) == null ? void 0 : _c.family) == null ? void 0 : _d.model)
        return (_g = (_f = (_e = this.offer) == null ? void 0 : _e.product) == null ? void 0 : _f.family) == null ? void 0 : _g.model;
      if (this.isBundle) {
        return this.brandName.reduce(
          (title, currentBrand) => title == null ? void 0 : title.replaceAll(currentBrand, ""),
          ((_j = (_i = (_h = this.offer) == null ? void 0 : _h.product) == null ? void 0 : _i.family) == null ? void 0 : _j.name) || ""
        );
      }
      return ((_m = (_l = (_k = this.offer) == null ? void 0 : _k.product) == null ? void 0 : _l.family) == null ? void 0 : _m.name) || "";
    },
    brandName() {
      var _a, _b, _c, _d, _e;
      if (!((_a = this.offer) == null ? void 0 : _a.product))
        return [];
      const { bundledProducts } = this.offer.product;
      if (!bundledProducts)
        return ((_e = (_d = (_c = (_b = this.offer) == null ? void 0 : _b.product) == null ? void 0 : _c.family) == null ? void 0 : _d.brand) == null ? void 0 : _e.name) || [];
      const bundledBrands = bundledProducts.map(({ family }) => {
        var _a2;
        return (_a2 = family == null ? void 0 : family.brand) == null ? void 0 : _a2.name;
      }).filter(Boolean);
      return [...new Set(bundledBrands)];
    },
    /**
     * A property for displaying the brandName in the template
     * brandName returns an array for bundles
     * @returns {String}
     */
    brandNameDisplay() {
      if (this.isBundle) {
        if (this.brandName.length > 1)
          return "";
        return this.brandName[0] || "";
      }
      return this.brandName;
    },
    offerLink() {
      var _a, _b, _c, _d;
      if ((_b = (_a = this.offer) == null ? void 0 : _a.contract) == null ? void 0 : _b.slug)
        return `/service/${this.offer.contract.slug}`;
      if ((_d = (_c = this.offer) == null ? void 0 : _c.product) == null ? void 0 : _d.slug)
        return `/geraete/${this.offer.product.slug}`;
      return "";
    },
    articleNumber() {
      var _a, _b;
      return ((_b = (_a = this.offer) == null ? void 0 : _a.product) == null ? void 0 : _b.articleNumber) || "";
    },
    price() {
      return getPriceFormatted(this.offer.prices || [], "DEFAULT", "ONETIME", this.priceOptions);
    },
    wasPrice() {
      return getPriceFormatted(this.offer.prices || [], "WAS", "ONETIME", this.priceOptions);
    },
    priceMonthly() {
      return getPriceFormatted(this.offer.prices || [], "DEFAULT", "MONTHLY", this.priceOptions);
    },
    wasPriceMonthly() {
      return getPriceFormatted(this.offer.prices || [], "WAS", "MONTHLY", this.priceOptions);
    },
    colorVariantOffers() {
      var _a, _b, _c;
      return (_c = (_b = (_a = this.transformedAlternative) == null ? void 0 : _a.variants) == null ? void 0 : _b.COLOR) == null ? void 0 : _c.items;
    },
    storageVariants() {
      var _a, _b, _c;
      return (_c = (_b = (_a = this.transformedAlternative) == null ? void 0 : _a.variants) == null ? void 0 : _b.STORAGE) == null ? void 0 : _c.items;
    },
    sizeVariants() {
      var _a, _b, _c;
      return (_c = (_b = (_a = this.transformedAlternative) == null ? void 0 : _a.variants) == null ? void 0 : _b.SIZE) == null ? void 0 : _c.items;
    },
    priceVariants() {
      var _a, _b, _c;
      return (_c = (_b = (_a = this.transformedAlternative) == null ? void 0 : _a.variants) == null ? void 0 : _b.PRICE) == null ? void 0 : _c.items;
    },
    hasStock() {
      var _a, _b, _c;
      return ((_c = (_b = (_a = this.offer) == null ? void 0 : _a.product) == null ? void 0 : _b.availability) == null ? void 0 : _c.stock) > 0;
    },
    transformedAlternative() {
      var _a;
      return getFirstOfferAlternatives(((_a = this.offer) == null ? void 0 : _a.productAlternatives) || []);
    },
    isBundle() {
      var _a, _b;
      return ((_b = (_a = this.offer) == null ? void 0 : _a.product) == null ? void 0 : _b.bundle) && this.offer.product.bundledProducts.length;
    },
    provider() {
      var _a, _b, _c;
      return ((_c = (_b = (_a = this.offer) == null ? void 0 : _a.product) == null ? void 0 : _b.availability) == null ? void 0 : _c.provider) || "";
    }
  }
};
var _sfc_render = function render() {
  var _a;
  var _vm = this, _c = _vm._self._c;
  return _c("article", { class: [
    "offer-tile",
    {
      "offer-tile--highlight-tile": _vm.highlightTile
    }
  ], attrs: { "data-articlenumber": _vm.articleNumber, "data-has-stock": _vm.hasStock, "data-provider": _vm.provider } }, [_c("LinkButton", { staticClass: "offer-tile__link-wrapper", attrs: { "tealium-name": _vm.title, "to": _vm.offerLink, "no-styling": "", "tag": _vm.linkTag, "title": "Zur Produktseite" } }, [_c("div", { staticClass: "offer-tile__flag-wrapper" }, [_vm.$slots.rectangularBadge ? _c("div", { staticClass: "offer-tile__rectangular-badge", style: `--rectangular-badge-bg: #${_vm.rectangularBadgeHex};` }, [_vm._t("rectangularBadge", null, { "offer": _vm.offer })], 2) : _vm._e(), _vm.$slots.highlightFlag ? _c("div", { staticClass: "offer-tile__highlight-flag", style: `--highlight-flag-bg: #${_vm.highlightFlagHex};` }, [_vm._t("highlightFlag", null, { "offer": _vm.offer })], 2) : _vm._e()]), _c("div", { staticClass: "offer-tile__header" }, [_vm._t("headerBefore", null, { "offer": _vm.offer }), _vm.colorVariantOffers ? _c("div", { staticClass: "offer-tile__variants" }, [_vm._t("variants", function() {
    return [_c("OfferTileColors", { attrs: { "variants": _vm.colorVariantOffers } })];
  }, { "offer": _vm.offer, "colorVariants": _vm.colorVariantOffers })], 2) : _vm._e(), _c("div", { staticClass: "offer-tile__image-wrapper" }, [_vm._t("image", null, { "offer": _vm.offer, "title": _vm.title })], 2)], 2), _c("div", { staticClass: "offer-tile__title-wrapper" }, [_vm.brandName.length && !_vm.noTextBrand ? _c("span", { staticClass: "offer-tile__brand filter-invert", attrs: { "aria-hidden": "true" } }, [_vm._t("brand", function() {
    return [_vm._v(" " + _vm._s(_vm.brandNameDisplay) + " ")];
  }, { "offer": _vm.offer })], 2) : _vm._e(), _vm._t("title", function() {
    return [_c("Heading", { staticClass: "offer-tile__title", attrs: { "tag": _vm.tagTitle, "align": "left", "itemprop": "name", "size": "sm", "font-weight": "ultra" } }, [_vm._v(" " + _vm._s(_vm.title) + " ")])];
  }, { "offer": _vm.offer, "title": _vm.title })], 2), _vm._t("headerAfter", null, { "offer": _vm.offer }), _c("div", { staticClass: "offer-tile__content" }, [_vm._t("contentBefore", null, { "offer": _vm.offer }), _vm.sizeVariants ? _c("div", { staticClass: "offer-tile__sizes" }, [_vm._t("sizes", function() {
    return [_c("OfferTileVariant", { attrs: { "variants": _vm.sizeVariants, "type": "size" } })];
  }, { "offer": _vm.offer })], 2) : _vm._e(), _vm.storageVariants ? _c("div", { staticClass: "offer-tile__storages" }, [_vm._t("storage", function() {
    return [_c("OfferTileVariant", { attrs: { "variants": _vm.storageVariants, "type": "storage" } })];
  }, { "offer": _vm.offer })], 2) : _vm._e(), _vm.$slots.offerContract ? _c("div", { staticClass: "offer-tile__contract-infos" }, [_vm._t("offerContract", null, { "offer": _vm.offer })], 2) : _vm._e(), _vm.$slots.energyLabel ? _c("div", { staticClass: "offer-tile__energy-label" }, [_vm._t("energyLabel", null, { "offer": _vm.offer })], 2) : _vm._e(), _vm._t("alternatives"), _vm.price || _vm.priceMonthly ? _c("div", { staticClass: "offer-tile__prices", attrs: { "aria-hidden": "true" } }, [_vm._t("price", function() {
    return [_vm.price ? _c("Prices", { attrs: { "is-price": _vm.price, "was-price": _vm.wasPrice, "pre-text-was-price": "", "pre-text-is-price": "", "post-text-is-price": _vm.priceMonthly && !_vm.wasPrice ? "einmalig" : "", "post-text-was-price": _vm.priceMonthly && _vm.wasPrice ? "einmalig" : "", "variant": "small", "is-price-bold": "" } }) : _vm._e(), _vm.priceMonthly ? _c("Prices", { attrs: { "is-price": _vm.priceMonthly, "was-price": _vm.wasPriceMonthly, "pre-text-was-price": "", "pre-text-is-price": "", "post-text-is-price": _vm.wasPriceMonthly ? "" : "monatlich", "post-text-was-price": _vm.wasPriceMonthly ? "monatlich" : "", "variant": "small", "is-price-bold": "" } }) : _vm._e()];
  }, { "offer": _vm.offer })], 2) : _vm._e(), ((_a = _vm.priceVariants) == null ? void 0 : _a.length) === 2 ? _c("div", { staticClass: "offer-tile__price-variants" }, [_vm._t("price-variants", function() {
    return [_c("OfferTileVariant", { attrs: { "variants": _vm.priceVariants, "type": "price" } })];
  }, { "offer": _vm.offer, "pricesVariants": _vm.priceVariants })], 2) : _vm._e(), _vm.$slots.info ? _c("div", { staticClass: "offer-tile__info" }, [_vm._t("info", null, { "offer": _vm.offer })], 2) : _vm._e(), _vm.$slots.button ? _c("div", { staticClass: "offer-tile__button" }, [_vm._t("button", null, { "offer": _vm.offer })], 2) : _vm._e(), _vm._t("contentAfter", null, { "offer": _vm.offer })], 2)], 2)], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "a9d77760",
  null,
  null
);
const offerTile = __component__.exports;
export {
  offerTile as default
};
